import { useCallback, useState } from "react";
import { image1 } from "../../assets/images";
import { ImageSource } from "@features/upload/types";
import { resolveImageUrl } from "@features/upload/helpers";

type ImageVariant = "profile" | "machinery" | "company" | "default";

const DEFAULT_FALLBACK = "https://www.shareicon.net/data/512x512/2016/07/05/791214_man_512x512.png";

export const FALLBACK_MAP: Record<ImageVariant, string> = {
    profile: DEFAULT_FALLBACK,
    machinery: image1,
    company: "/images/company-fallback.png",
    default: DEFAULT_FALLBACK,
};

interface UseImageOptions {
    src?: ImageSource;
    variant?: ImageVariant;
    fallbackSrc?: string;
}

export function useImage({ src, variant = "default", fallbackSrc }: UseImageOptions) {
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(false);

    const fallback = fallbackSrc ?? FALLBACK_MAP[variant];
    const resolvedSrc = resolveImageUrl(error || !src ? fallback : src);

    const ref = useCallback((node: HTMLImageElement | null) => {
        if (node?.complete && node.naturalWidth > 0) {
            requestAnimationFrame(() => setLoaded(true));
        }
    }, []);

    const onLoad = useCallback(() => setLoaded(true), []);
    const onError = useCallback(() => { setError(true); setLoaded(true); }, []);

    return { ref, resolvedSrc, loaded, onLoad, onError };
}